import React from "react";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IHistory } from "../../types/history.type";
import { formatDate, formatTime } from "../../utils/formatDate";
import styles from "./styles.module.scss";

interface Props {
  history: IHistory[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: IHistory) => void;
}

const HistoryTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Type</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.history &&
          props.history?.length > 0 &&
          props.history.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.nameContainer}>
                  <span className={styles.name}>
                    {formatTime(user.createdAt)}
                  </span>
                  <span className={styles.email}>
                    {formatDate(user.createdAt)}
                  </span>
                </div>
              </td>
              <td>{user.operationType}</td>
              <td className={styles.role}>{"Test"}</td>

              <td>
                <div className={styles.actions}>
                  {/* <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.callBackInfo(false);
                      props.callBackEdit(user);
                    }}
                  >
                    <EditIcon />
                  </button> */}
                  <button
                    className={styles.infoBtn}
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(user);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default HistoryTable;
